import { inject } from '@angular/core'
import { Router, CanActivateFn, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { take, map } from 'rxjs/operators'
import { ProfilingService } from './profiling.service'

export const profileCompleteGuard: CanActivateFn = (): Observable<
  boolean | UrlTree
> => {
  const router = inject(Router)
  const profileService = inject(ProfilingService)

  return profileService.isProfileCompleted$.pipe(
    take(1),
    map((isComplete) => (isComplete ? true : router.parseUrl('/user-form')))
  )
}
